export default {
	// api请求地址
	baseUrl: 'https://shop.yousin.cn',
	// baseUrl: 'https://v5.niuteam.cn',
	// baseUrl: 'http://www.niushop.com/index.php',
	// baseUrl: 'http://www.niushop.com/index.php',
	
	// 图片域名
	imgDomain: 'https://shop.yousin.cn',
	// imgDomain: 'https://v5.niuteam.cn',
	
	// 前端域名
	webDomain: 'https://shop.yousin.cn/web',
	
	// 腾讯地图key
	mpKey: 'IZQBZ-3UHEU-WTCVD-2464U-I5N4V-ZFFU3',
	
	// 客服
	webSocket: 'wss://shop.yousin.cn/wss',
	
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500
}